import { render, staticRenderFns } from "./FolderSync.vue?vue&type=template&id=16f61874"
import script from "./FolderSync.vue?vue&type=script&lang=js"
export * from "./FolderSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports